import React from 'react';
import './toggleSwitch.style.scss'; // Optional: for styling if using an external stylesheet

const ToggleSwitch = ({ isOn, handleToggle }) => {
  return (
    <div className={`toggle-switch${isOn ? '-checked' : ''}`}>
      <input
        checked={isOn}
        onChange={handleToggle} // Using onChange instead of onClick
        className="toggle-switch-checkbox"
        id={`react-switch-new`}
        type="checkbox"
      />
      <label
        className="toggle-switch-label"
        htmlFor={`react-switch-new`}
      >
        <span className={`toggle-switch-inner`} />
        <span className={`toggle-switch-switch`} />
      </label>
    </div>
  );
};

export default ToggleSwitch;